import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listConsignState, listConsignDeliveryState } from '@/api/dict.js';
import { listAgentSellOrder, listAgentSellOrderDetail, listAgentSellOrderExport } from '@/api/order.js';
import { listDealerUserManufacturer, findDealerUserManu } from '@/api/manufacturer.js';
import YTable from '@/views/components/table/index.vue';
import { listStockOutOrder } from '@/api/stock.js';
import dayjs from 'dayjs';
import { listBrand } from '@/api/brand.js';
export default {
  name: 'order-consign-index',
  components: {
    YTable: YTable
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    var _this = this;

    return {
      dataList: [],
      // 订单列表
      dataLoading: false,
      deliveryStateList: [],
      initialized: false,
      searchForm: {
        orderNumber: null,
        // 订单编号
        state: null,
        // 状态 1=暂存,2=提交,3=部分发货,4=全部发货,5=作废,6=结单,7=待审核,8=暂存,9=驳回
        sellDateStart: null,
        // 销售日期
        sellDateEnd: null,
        distributorId: null,
        // 分销商ID
        dateRange: ['', ''],
        invoiceNumber: null,
        // 发票号
        remarks: null,
        // 备注
        page: 1,
        pageSize: 5,
        total: 0,
        source: null,
        deliveryState: null,
        statisticsState: null,
        statisticsDeliveryState: [],
        stockoutStatus: null
      },
      searchMode: 'FORM',
      timestamp: new Date().valueOf(),
      stateList: [],
      // 状态列表
      manufacturerList: [],
      // 经销商列表
      searchFormExpand: false,
      // 是否展开搜索表单
      detailList: [],
      // 订单产品列表
      detailLoading: false,
      // 订单产品列表loading
      detailForm: {
        sellOrderId: null,
        page: 1,
        pageSize: 5,
        total: 0
      },
      dataTableCurrentRow: null,
      detailTableCurrentRow: null,
      dataTableCacheName: 'SC-' + this.$route.name + '-data-table',
      detailTableCacheName: 'SC-' + this.$route.name + '-detail-table',
      columns: [{
        label: '寄售单号',
        prop: 'orderNumber',
        checked: true,
        width: 200
      }, {
        label: '创建人',
        prop: 'createdByName',
        checked: true,
        width: 150,
        slot: 'createdByName'
      }, {
        label: '客户名称',
        prop: 'distributorName',
        checked: true,
        width: 200
      }, {
        label: '订单状态',
        prop: 'state',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          var findRow = _this.stateList.find(function (item) {
            return item.ID === val;
          });

          if (findRow) {
            return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
          } else {
            return val;
          }
        }
      }, {
        label: '发货状态',
        prop: 'deliveryState',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          var findRow = _this.deliveryStateList.find(function (item) {
            return item.ID === val;
          });

          if (findRow) {
            return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
          } else {
            return val;
          }
        }
      }, {
        label: '采购日期',
        prop: 'sellDate',
        checked: true,
        width: 100
      }, {
        label: '数量',
        prop: 'sumQuantity',
        checked: true,
        width: 100
      }, {
        label: '订单金额',
        prop: 'sumAmount',
        checked: true,
        width: 150,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '备注',
        prop: 'remarks',
        checked: true,
        width: 200,
        fixedWidth: true
      }, {
        label: '操作',
        prop: 'operations',
        checked: true,
        width: 150,
        fixedWidth: true,
        fixed: 'right',
        slot: 'operations'
      }],
      detailColumns: [{
        label: '产品编号',
        prop: 'productNumber',
        checked: true,
        width: 150
      }, {
        label: '产品名称',
        prop: 'productName',
        checked: true,
        width: 150
      }, {
        label: '规格型号',
        prop: 'specificationModel',
        checked: true,
        width: 200
      }, {
        label: '单位',
        prop: 'unit',
        checked: true,
        width: 100
      }, {
        label: '数量',
        prop: 'sellQuantity',
        checked: true,
        width: 100
      }, {
        label: '单价',
        prop: 'sellUnitPrice',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '价格',
        prop: 'sellAmount',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '注册/备案证',
        prop: 'registrationNumber',
        checked: true,
        width: 200
      }, {
        label: '厂家',
        prop: 'manufacturer',
        checked: true,
        width: 200
      }, {
        label: '通用名称',
        prop: 'genericName',
        checked: true,
        width: 120,
        fixedWidth: true
      }],
      tabList: [{
        ID: 1,
        name: '全部',
        number: 0,
        statisticsState: null,
        statisticsDeliveryState: []
      }, {
        ID: 2,
        name: '审核中',
        number: 0,
        statisticsState: 11,
        statisticsDeliveryState: []
      }, {
        ID: 3,
        name: '待发货',
        number: 0,
        statisticsState: 2,
        statisticsDeliveryState: [2, 3]
      }, {
        ID: 4,
        name: '收货确认',
        number: 0,
        statisticsState: null,
        statisticsDeliveryState: [],
        stockoutStatus: [4]
      }, {
        ID: 6,
        name: '已收货',
        number: 0,
        statisticsState: null,
        statisticsDeliveryState: [],
        stockoutStatus: [6]
      }, {
        ID: 5,
        name: '驳回',
        number: 0,
        statisticsState: 9,
        statisticsDeliveryState: []
      }],
      expandRowKeys: [],
      brandList: [],
      activeTabId: 1
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this2;
                that.dataLoading = false;
                that.stateList = listConsignState();
                that.deliveryStateList = listConsignDeliveryState();
                _context.next = 6;
                return that.loadManufacturer();

              case 6:
                if (that.initialized) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return that.loadData();

              case 9:
                that.initialized = true;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this3;
                that.dataList = [];
                that.detailList = [];
                that.dataLoading = true;
                query = JSON.parse(JSON.stringify(that.searchForm));

                if (query.dateRange) {
                  if (query.dateRange[0] && query.dateRange[1]) {
                    query.sellDateStart = query.dateRange[0];
                    query.sellDateEnd = query.dateRange[1];
                  }

                  delete query.dateRange;
                }

                _context2.next = 8;
                return that.loadBrand();

              case 8:
                _context2.next = 10;
                return listAgentSellOrder(query).then(function (res) {
                  res.list.map(function (row) {
                    row.expandRowKeys = [];
                  });
                  that.dataList = res.list;
                  that.searchForm.total = res.total;

                  if (that.dataTableCurrentRow) {
                    that.$refs.dataTableRef.setCurrentRow(that.dataTableCurrentRow, true);
                  }

                  that.tabList[0].number = res.other.total;
                  that.tabList[1].number = res.other.checkoutNum;
                  that.tabList[2].number = res.other.waitDeliverNum;
                  that.tabList[3].number = res.other.waitForReceiving;
                  that.tabList[4].number = res.other.receiptConfirm;
                  that.tabList[5].number = res.other.rejectNum;
                }).catch(function (e) {});

              case 10:
                that.dataLoading = false;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loadBrand: function loadBrand() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this4;
                _context3.next = 3;
                return listBrand({
                  page: 1,
                  pageSize: 9999
                }).then(function (res) {
                  that.brandList = res.list;
                }).catch(function (e) {});

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    dataExport: function dataExport() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this5;
                form = JSON.parse(JSON.stringify(that.searchForm));
                form.toExcel = 1;
                _context4.next = 5;
                return listAgentSellOrderExport(form).then(function (res) {
                  var blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
                  }); // type这里表示xlsx类型

                  // type这里表示xlsx类型
                  var downloadElement = document.createElement('a');
                  var href = window.URL.createObjectURL(blob); // 创建下载的链接

                  // 创建下载的链接
                  downloadElement.href = href;
                  downloadElement.download = '寄售订货订单.xlsx'; // 下载后文件名

                  // 下载后文件名
                  document.body.appendChild(downloadElement);
                  downloadElement.click(); // 点击下载

                  // 点击下载
                  document.body.removeChild(downloadElement); // 下载完成移除元素

                  // 下载完成移除元素
                  window.URL.revokeObjectURL(href); // 释放掉blob对象
                }).catch(function () {});

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.searchMode = 'FORM';
      that.loadData();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    dataRowClick: function dataRowClick(row) {
      var that = this;
      that.dataTableCurrentRow = row;
      that.detailForm.page = 1;
      that.detailForm.total = 0;
      that.detailForm.sellOrderId = row.ID;
      that.loadDetail();
    },
    dataRowDbClick: function dataRowDbClick(row) {
      var that = this;
      that.dataTableCurrentRow = row;
      that.dataEdit(row);
    },
    dataCreate: function dataCreate() {
      var that = this;
      that.$router.push({
        path: '/order/consign/create'
      });
    },
    dataEdit: function dataEdit(row) {
      var that = this;
      that.$router.push({
        path: '/order/consign/detail/' + row.ID
      });
    },
    loadManufacturer: function loadManufacturer() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this6;
                that.manufacturerList = [];
                _context5.next = 4;
                return listDealerUserManufacturer().then(function (res) {
                  that.manufacturerList = res.list;
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    loadDetail: function loadDetail() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, isDisplayPrice, query;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this7;
                that.detailList = [];
                that.detailLoading = true;
                isDisplayPrice = 2;
                _context6.next = 6;
                return findDealerUserManu({
                  manuId: that.dataTableCurrentRow.distributorId
                }).then(function (res) {
                  isDisplayPrice = res.redealerUser.isDisplayPrice || 2;
                }).catch(function (e) {});

              case 6:
                if (isDisplayPrice === 1) {
                  that.detailColumns.forEach(function (row, index) {
                    if (['单价', '价格'].includes(row.label)) {
                      that.detailColumns[index].hide = false;
                    }
                  });
                } else {
                  that.detailColumns.forEach(function (row, index) {
                    if (['单价', '价格'].includes(row.label)) {
                      that.detailColumns[index].hide = true;
                    }
                  });
                }

                query = {
                  sellOrderId: that.dataTableCurrentRow.ID,
                  page: 1,
                  pageSize: 9999
                };
                _context6.next = 10;
                return listAgentSellOrderDetail(query).then(function (res) {
                  res.list.map(function (row) {
                    that.detailList.push({
                      ID: row.ID,
                      productNumber: row.specs.productNumber,
                      productName: row.main.productName,
                      specificationModel: row.specs.specificationModel,
                      unit: row.specs.unit,
                      sellQuantity: row.sellQuantity,
                      sellUnitPrice: row.sellUnitPrice,
                      sellAmount: row.sellAmount,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      genericName: row.specs.genericName
                    });
                  });
                  that.detailForm.total = res.total;

                  if (that.detailTableCurrentRow) {
                    that.$refs.detailTableRef.setCurrentRow(that.detailTableCurrentRow, true);
                  }
                }).catch(function (e) {});

              case 10:
                that.detailLoading = false;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    detailPageChange: function detailPageChange(page) {
      var that = this;
      that.detailForm.page = page;
    },
    detailSizeChange: function detailSizeChange(pageSize) {
      var that = this;
      that.detailForm.pageSize = pageSize;
      that.detailForm.page = 1;
    },
    detailRowClick: function detailRowClick(row) {
      var that = this;
      that.detailTableCurrentRow = row;
    },
    stateFormatter: function stateFormatter(val) {
      var findRow = this.stateList.find(function (item) {
        return item.ID === val;
      });

      if (findRow) {
        return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
      } else {
        return val;
      }
    },
    tabChange: function tabChange(item) {
      var that = this;
      that.activeTabId = item.ID;
      that.searchMode = 'TAB';
      that.searchForm.statisticsState = item.statisticsState;
      that.searchForm.statisticsDeliveryState = item.statisticsDeliveryState;
      that.searchForm.stockoutStatus = item.stockoutStatus;
      that.loadData();
    },
    deliveryShow: function deliveryShow(row) {
      var that = this;
      var query = {
        issueType: 5,
        status: 6,
        sellOrderId: row.ID,
        page: 1,
        pageSize: 9999
      };
      listStockOutOrder(query).then(function (res) {
        res.list.map(function (row) {
          row.deliveryTime = dayjs(row.deliveryTime).format('YYYY-MM-DD HH:mm:ss');
          row.deliveryQuantity = 0;
          row.stockoutInfo.map(function (row2) {
            row.deliveryQuantity += row2.deliveryQuantity;
          });
        });
        that.$set(row, 'stockout', res.list);
      }).catch(function (e) {});
    },
    deliveryRowClick: function deliveryRowClick(row) {
      var that = this;
      var expandRowKeys = that.expandRowKeys;

      if (that.expandRowKeys.indexOf(row.deliveryOrderNo) === -1) {
        expandRowKeys.push(row.deliveryOrderNo);
      } else {
        expandRowKeys.splice(that.expandRowKeys.indexOf(row.deliveryOrderNo), 1);
      }

      that.$set(that, 'expandRowKeys', expandRowKeys);
    },
    toReceive: function toReceive(row) {
      var that = this;
      that.$router.push({
        path: '/order/consign/detail/' + row.ID + '/RECEIVE'
      });
    }
  }
};